import { render, staticRenderFns } from "./FacilityCreateRegistration.vue?vue&type=template&id=ef77f636&"
import script from "./FacilityCreateRegistration.vue?vue&type=script&lang=js&"
export * from "./FacilityCreateRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports